import {
  AfterViewInit,
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { InspirationSubNavContainerBaseDirective } from './inspiration-sub-nav-container-base.directive';

@Directive({
  selector: '[idpInspirationSubNavContainer]',
  standalone: true
})
export class InspirationSubNavContainerDirective
  extends InspirationSubNavContainerBaseDirective
  implements AfterViewInit, OnChanges
{
  @Output() appScrolled = new EventEmitter<void>();
  @Output() appScrolledToTop = new EventEmitter<string>();
  @Input() APP_DISABLE_LEGACY = true;
  @Input() selectedNav = '';
  @Input() selectedBookingTab = '';

  private isClickInProgress = false;
  private lastScrollY = 0;
  private navBeforeScroll = '';
  private wasAtTop = true;

  @HostListener('window:scroll') onWindowScroll(): void {
    this.setInspireMenuPosition();
    if (this.APP_DISABLE_LEGACY) return;
    if (this.handleScrollToTop()) return;
    if (this.shouldSuppressScroll()) return;
    this.navBeforeScroll = this.selectedNav;
    setTimeout(() => {
      const overlayBackdrop = document.querySelector(
        '.cdk-overlay-backdrop-showing'
      ) as HTMLElement;
      if (overlayBackdrop) return;
      this.appScrolled.emit();
    }, 100);
  }

  private handleScrollToTop(): boolean {
    const atTop = window.scrollY === 0;
    if (atTop && !this.wasAtTop && this.navBeforeScroll) {
      this.wasAtTop = true;
      this.appScrolledToTop.emit(this.navBeforeScroll);
      return true;
    }
    this.wasAtTop = atTop;
    return false;
  }

  private shouldSuppressScroll(): boolean {
    return (
      this.isClickInProgress || !this.isScrollingDown() || !this.selectedNav
    );
  }

  private isScrollingDown(): boolean {
    const current = window.scrollY;
    const down = current > this.lastScrollY;
    if (!this.isClickInProgress) this.lastScrollY = current;
    return down;
  }

  @HostListener('document:mousedown') onMouseDown(): void {
    if (this.APP_DISABLE_LEGACY) return;
    this.isClickInProgress = true;
    setTimeout(() => (this.isClickInProgress = false), 600);
  }

  @HostListener('document:click', ['$event']) onClick(e: Event): void {
    if (this.APP_DISABLE_LEGACY) return;
    this.inspirationSubNavClicked = !!(
      e.target as HTMLElement
    )?.classList[0]?.includes('inspiration-sub-nav-link');
    this.setInspireMenuPosition();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setInspireMenuPosition();
      this.positionDeltaLogo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedNav'] || changes['selectedBookingTab'])
      setTimeout(() => this.setInspireMenuPosition());
  }

  setInspireMenuPosition(): void {
    this.isInspireMenu = !!document.body.querySelector(
      '.inspiration-sub-nav-container'
    );
    this.checkInspireMenu();
    this.inspireSubNavPosition();
  }

  checkInspireMenu(): void {
    if (this.APP_DISABLE_LEGACY) return;
    this.handleSkipContent();
    this.handleInspireMenu();
    this.handleBodyMargin();
    this.isLegacyApp = true;
  }

  handleBodyMargin(): void {
    this.rend.setStyle(document.body, 'margin', '0');
  }

  handleSkipContent(): void {
    const skipLink = document.querySelector('.skip-content-container a');
    if (skipLink) skipLink.classList.add('skip-main-content');
  }

  handleInspireMenu(): void {
    this.isInspireMenu = !!document.body.querySelector(
      '.inspiration-sub-nav-container'
    );
  }

  inspireSubNavPosition(): void {
    if (!this.isInspireMenu) return;
    this.headerHeight = this.calculateTotalHeight();
    this.positionSubNav();
  }
}
